module.exports = __webpack_public_path__ + "img/map2.f6b38472.jpg";